import { useState } from "react";
import { GridInputs } from "../../../../../../../components/Functional";
import { TrashIcon } from "@heroicons/react/24/outline";
import { IconButton, Button } from "../../../../../../../components/ui";
import useEntityImageUpload from "../../../../../../../hooks/useEntityImageUpload";

const UpdateImage = props => {
  const { closeModal, company, values } = props || {};
  const { uploadEntityImage, deleteEntityImage, loading } =
    useEntityImageUpload({ refetchQueries: ["FetchCompany"] });

  const [imageState, setImageState] = useState({
    url: company?.images?.[values.key],
    file: null,
    deleted: false,
  });

  const handleSubmit = async () => {
    if (imageState.deleted) {
      await deleteEntityImage({
        entityType: "company",
        entityId: company.id,
        imageType: values.key,
      });
    } else if (imageState.file) {
      await uploadEntityImage({
        entityType: "company",
        entityId: company.id,
        imageType: values.key,
        file: imageState.file,
      });
    }
    closeModal();
  };

  const ImgInputLabel = ({ label }) => {
    return (
      <div className="flex justify-between">
        <div className="mb-2 text-lg font-bold">{label}</div>
        <IconButton variant="clean" title="Delete Role">
          <TrashIcon
            className={`h-4 w-4 cursor-pointer text-gray-400`}
            onClick={() =>
              setImageState({ url: null, file: null, deleted: true })
            }
          />
        </IconButton>
      </div>
    );
  };

  const inputs = {
    className: "grid grid-cols-1",
    inputs: [
      {
        className: "grid grid-cols-1 gap-8",
        inputs: [
          {
            label: <ImgInputLabel label={values.type} />,
            name: values.key,
            type: "img",
            w: "w-full",
            h: "h-96",
            value: imageState.url,
            onChange: e => {
              const files = e?.target?.files;
              const url = URL.createObjectURL(files[0]);
              setImageState({ url, file: files?.[0], deleted: false });
            },
          },
        ],
      },
    ],
  };

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-4 sm:flex-row">
        <div className="flex flex-1 flex-col text-2xl font-bold">
          <div>Edit {values.type} image</div>
        </div>
        <div className="flex gap-4">
          <Button
            action="default"
            label="Cancel"
            onClick={closeModal}
          />
          <Button
            label={"Update"}
            loading={loading}
            disabled={loading}
            onClick={handleSubmit}
          />
        </div>
      </div>
      <div className="grid">
        <GridInputs {...inputs} />
      </div>
    </div>
  );
};

export default UpdateImage;
